var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.00065 16.6667C4.54232 16.6667 4.14982 16.5034 3.82315 16.1767C3.49649 15.85 3.33343 15.4578 3.33399 15V12.5H5.00065V15H15.0007V12.5H16.6673V15C16.6673 15.4584 16.504 15.8509 16.1773 16.1775C15.8507 16.5042 15.4584 16.6673 15.0007 16.6667H5.00065ZM10.0007 13.3334L5.83399 9.16671L7.00065 7.95837L9.16732 10.125V3.33337H10.834V10.125L13.0007 7.95837L14.1673 9.16671L10.0007 13.3334Z",
    fill: "#0B93E3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f0c9487c0079423fa42b7694cb457e5d.svg";
export { ForwardRef as ReactComponent };